export default {
  methods: {
 
    // hasPermissions(permissions, opts) Given a permissions array, return if this user has any of these permissions in any of their roles. Using a custom validator, you can exclude certain roles from qualifying (ie: only wanting to know if they have a Company level role that qualifies). "opts: {array: true} will return an array of all roles that meet the given criteria.
    hasPermissions (permissions, opts) {

      if (!permissions) return true; // If no permissions are passed, there must be no restriction
      
      opts = opts || {};
      
      var permitted = opts.array ? [] : false;
      var roles = this.$store.getters.profile.roles || false;
    
      // Check restrictions
      var validator = opts.validator || false;

      if (!roles) return false;
      roles.some(role => {
        
        // Make sure this role fits the criteria required before checking for any permisisons
        if (!validator || validator(role)) {

          permissions.some(perm => {
            if (perm in role.permissions && role.permissions[perm]) {
              if (opts.array) permitted.push(role);
              else            permitted = true;
              return          permitted;
            }
          });
        }

        // If we're not building an array, we can leave now
        if (!opts.array && permitted) return;
      })

      return permitted;
    },

    // hasPermissionsInProperty(permissions, property, opts) Same as hasPermissions, but will restrict to any role within a given property.
    hasPermissionsInProperty (permissions, property, opts) {
      opts = opts || {};

      opts.validator = (role) => {
        return (!role.property) || (role.property === property);
      };

      return this.hasPermissions(permissions, opts);
    },

    // hasPermissionsInPropertyRole(permissions, property, opts) Same as hasPermissions, but will restrict to any role within a given property, where the role must be at least property level or higher to qualify.
    hasPermissionsInPropertyRole(permissions, property, opts) {
      opts = opts || {};

      opts.validator = (role) => {
        // Excludes unit roles from this result
        return (!role.unit && (!role.property || (role.property === property)));
      };

      return this.hasPermissions(permissions, opts);
    },

    // hasPermissionsInCompanyRole(permissions, opts) Same as hasPermissions, but will restrict to only company level roles
    hasPermissionsInCompanyRole(permissions, opts) {
      
      // Only allows roles that are company level
      var companyValidator = function (role) {
        return (role.company && !role.property && !role.unit);
      };

      return this.hasPermissions(permissions, { validator: companyValidator })
    },

    // getPropertiesWithPermissions(permissions) - Returns an array of all properties in which the user has this permission
    getPropertiesWithPermissions (permissions) {

      // Get an array of roles the user has with this permission
      var roles = this.hasPermissions(permissions, { array: true })

      // Add each property that's not already on the list
      var properties = [];
      roles.forEach(r => {
        if (r.property && !(properties.includes(r.property))) properties.push(r.property);
      });

      return properties; 
    },

    // getUnitsWithPermissions(permissions) - Returns an array of all unit roles in which the user has this permission
    getUnitsWithPermissions (permissions, property) {
  
      // Only allows roles that are company level
      var unitValidator = function (role) {
        return (role.property && role.property === property && role.unit);
      };

      var roles = this.hasPermissions(permissions, {validator: unitValidator, array: true })

      // Add each unit not already on the list
      var units = [];
      roles.forEach(r => {
        if (r.unit && !(units.includes(r.unit))) units.push(r.unit);
      });

      return units;
    },

    // getAccessiblePropertiesList(permissions) - Returns an array of all properties this user has access to with the given permissions, accounting for Company level permissions granting access to all properties
    getAccessiblePropertiesList (permissions) {
      
      // User has all properties
      if (this.hasPermissionsInCompanyRole(permissions)) {
        return _.values(this.$store.getters.properties);
      }

      // User has some properties
      else {
        var properties = this.getPropertiesWithPermissions(permissions);
        var props = [];

        for (var i = 0; i < properties.length; ++i) {
          props.push(this.$store.getters.property(properties[i]));
        }
        return props;
      }      
    },

    // reroute(unauthorized, query) - Reroutes the user based on the permissions they have
    reroute (unauthorized, query) {
    
      var route = 'signout';
      
      // Find a route the user can access
      if (this.hasPermissions(['ticket', 'ticketManager', 'ticketAdmin'])) {
        route = 'tickets';
      }
      else if (this.hasPermissions(['user'])) {
        route = 'joined';
      }
      else if (this.hasPermissions(['unit'])) {
        route = 'units';
      }
      else if (this.hasPermissions(['property'])) {
        route = 'properties';
      }
      else if (this.hasPermissions(['role'])) {
        route = 'role';
      }
      else if (this.hasPermissions(['ticketType'])) {
        route = 'ticketType';
      }
      
      var params = {
        name: route
      };
      
      // Preserve query
      query = query || false;
      if (query) {
        params.query = query;
      }

      // Forceful redirect
      if (unauthorized) {
        Toast.show('You are unauthorized to view that page.', 'error');
        this.$router.replace(params);
      }

      // Friendly redirect
      else {
        this.$router.push(params);
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/mixins/permissionMixin.js